import React from 'react';
import { SEGMENT_FILL } from '../theme';

/** Swatch legend for the severity ramp; label count decides how many swatches show. */
const SegmentLegend = ({ labels, gap = 22 }) => (
  <div className='flex flex-wrap gap-x-ds-5 gap-y-ds-2' style={{ marginBottom: gap }}>
    {labels.map((label, index) => (
      <div key={label} className='flex items-center gap-[7px] text-[12px] text-gray-700'>
        <span className={`h-2.5 w-2.5 rounded-[3px] ${SEGMENT_FILL[index]}`} />
        {label}
      </div>
    ))}
  </div>
);

export default SegmentLegend;
